import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "MS-SymbolLockup" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 9,
			height: 9,
			fill: "#f25022"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 11,
			width: 9,
			height: 9,
			fill: "#00a4ef"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 1,
			width: 9,
			height: 9,
			fill: "#7fba00"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 11,
			width: 9,
			height: 9,
			fill: "#ffb900"
		})
	]
});
export default SvgMicrosoftLogo;
